import React from "react";
import Table from "../../layout/table.jsx";
import API from "../../../services/api.jsx";
import moment from "moment";
import { debounce } from "lodash";
import Loader from "../../layout/loader.jsx";
import Helpers from "../../../services/helpers.jsx";
import { toast } from "react-toastify";

class PlaylistList extends React.Component {
  constructor(props) {
    super(props);

    const columns = [
      {
        label: 'Playlist name',
        key: 'name',
        canSort: true,
        onSortClick: (column) => this.onSort(column.key),
      },
      {
        label: 'Tracks',
        key: 'assets',
        view: function (field) {
          if (!field) return '-';
          return field.length;
        },
      },
      {
        label: 'Duration',
        key: 'duration',
        canSort: true,
        onSortClick: (column) => this.onSort(column.key),
        view: function (field) {
          if (!field) return '-';

          return Helpers.formatTime(field);
        },
      },
      {
        label: 'Usage',
        key: 'linkedCampaigns',
        canSort: true,
        onSortClick: (column) => this.onSort(column.key),
      },
      {
        label: 'Vox tag',
        key: 'tag',
      },
      {
        label: 'Type',
        key: 'type',
        view: (field) => {
          return Helpers.getPlaylistTypeLabel(field);
        },
      },
      {
        label: 'Affiliate',
        key: 'affiliates',
        view: (field) => {
          if (Array.isArray(field)) {
            if (field.length === 0) {
              return 'All';
            } else {
              return field?.map((affiliate) => affiliate.name)?.join(', ');
            }
          } else {
            return '-';
          }
        },
      },
      {
        label: 'Creation date',
        key: 'createdAt',
        view: function (field) {
          return moment(field).format('l');
        },
      },
      {
        label: 'Modified date',
        key: 'updatedAt',
        canSort: true,
        onSortClick: (column) => this.onSort(column.key),
        view: function (field) {
          return moment(field).format('l');
        },
      },
    ];
    if (Helpers.checkPermissions("playlists:delete")) {
      columns.push({
        action: "delete",
        onClick: (id, key) => {
          var r = window.confirm(
            "Are you sure you want to delete this playlist?"
          );
          if (r === false) return;

          this.setState({ loading: true });
          API.delete("playlists", id)
            .then(() => {
              toast.success("Playlist was successfully deleted");
              this.loadEntities();
            })
            .catch(() => {
              // toast.success("An unexpected error has occurred");
              this.setState({ loading: false });
            });
        },
      });
    }

    const actions = [];
    if (Helpers.checkPermissions("playlists:edit")) {
      actions.push({
        classList: "blue add",
        label: "New playlist",
        onClick: () => this.props.history.push("/assets/playlists/new"),
      });
    }

    this.state = {
      loading: true,
      filters: {},
      sort: ["name", "ASC"],
      playlists: {
        columns,
        entities: [],
        filters: [],
        actions,
        selectedItems: [],
        multiSelect: false,
        onRowClick: (entity) => {
          if (
            Helpers.checkPermissions(
              ["playlists:details", "playlists:edit"],
              true
            )
          ) {
            this.props.history.push(
              `/clients/${this.props.match.params.clientId}/playlists/${entity.id}`
            );
          }
        },
      },
    };
  }

  componentDidMount() {
    this.loadEntities();
  }

  loadEntities() {
    API.getClientPlaylists(
      this.props.match.params.clientId,
      this.state.filters,
      this.state.sort
    ).then((entities) => {
      const filters = [];
      if (entities?.filters?.availableFilters) {
        Helpers.handleFilters(this, filters, entities);
      }

      this.setState({
        ...this.state,
        playlists: {
          ...this.state.playlists,
          filters,
          entities: entities?.data || [],
        },
        loading: false,
      });
    });
  }

  onSort(key) {
    const newSort =
      this.state?.sort?.[0] === key
        ? this.state?.sort?.[1] === "ASC"
          ? [key, "DESC"]
          : [key, "ASC"]
        : [key, "ASC"];
    this.setState(
      {
        sort: newSort,
      },
      () => {
        this.loadEntities();
      }
    );
  }

  render() {
    if (this.state.loading) return <Loader />;
    else
      return <Table settings={this.state.playlists} sort={this.state.sort} />;
  }
}

export default PlaylistList;
